import isMaybe from './isMaybe';
function Some(value) {
    return {
        _kind: 'Some',
        alt: function () { return Some(value); },
        map: function (fn) { return Some(fn(value)); },
        then: function (fn) {
            var valueOrMaybe = fn(value);
            return isMaybe(valueOrMaybe) ? valueOrMaybe : Some(valueOrMaybe);
        },
        chain: function (fn) { return fn(value); },
        match: function (_a) {
            var some = _a.some;
            return some(value);
        },
        fold: function (_, onSome) { return onSome(value); },
        isNone: function () { return false; },
        isSome: function () { return true; },
        getOrElse: function () { return value; },
        unwrap: function () { return value; },
    };
}
export default Some;
//# sourceMappingURL=Some.js.map